import React, { useEffect, useState } from 'react';
import { TextField, Button, FormControl, Typography, Box, Grid, Avatar } from '@mui/material';
import { Upload } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import BreadCrumbs from 'ui-component/cards/BreadCrumbs';
import SimpleModal from 'ui-component/modals/SimpleModal';
import { addTeams } from 'store/teams/actions';

const AddTeams = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  const [memberName, setMemberName] = useState('');
  const [memberDesignation, setMemberDesignation] = useState('');
  const [description, setDescription] = useState('');
  const [objectPositionValue, setObjectPositionValue] = useState(0);
  const [mainImage, setMainImage] = useState(null);
  const [mainImageURL, setMainImageURL] = useState('');

  const handleClickAdd = async (e) => {
    e.preventDefault();
    const data = {
      memberName,
      mainImage,
      description
    };

    const validationErrors = validateForm(data);
    if (Object.keys(validationErrors).length === 0) {
      const formData = new FormData();
      formData.append('memberName', memberName);
      formData.append('memberDesignation', memberDesignation);
      formData.append('mainImage', mainImage);
      formData.append('description', description);
      formData.append('objectPositionValue', objectPositionValue);

      try {
        await dispatch(addTeams(formData));
        navigate('/teams');
      } catch (error) {
        console.log('err', error);
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const validateForm = (data) => {
    let errors = {};
    if (!data.memberName.trim()) {
      errors.memberName = 'Name is required';
    }

    if (!data.mainImage) {
      errors.images = 'Image is required';
    }

    return errors;
  };

  const handleChangeFile = (e) => {
    if (e.target.files[0].size > 512500) {
      setOpen(true);
      return;
    }
    setMainImage(e.target.files[0]);
    setMainImageURL(URL.createObjectURL(e.target.files[0]));
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Grid container>
      <Grid item xs={12} md={12}>
        <BreadCrumbs title={'Add New Team Member'} sx={{ mb: 2 }} />
        <Grid item xs={12} md={12}>
          <Grid container>
            <Grid item xs={12} md={3.5}></Grid>
            <Grid item xs={12} md={5}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={12}>
                  <Box mb={2}>
                    <TextField
                      fullWidth
                      label="Member Name"
                      variant="outlined"
                      onChange={(e) => {
                        setErrors({ ...errors, ['memberName']: '' });
                        setMemberName(e.target.value);
                      }}
                      error={Boolean(errors.memberName)}
                      helperText={errors.memberName}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box mb={2}>
                    <TextField
                      fullWidth
                      label="Designation"
                      variant="outlined"
                      onChange={(e) => {
                        setErrors({ ...errors, ['memberDesignation']: '' });
                        setMemberDesignation(e.target.value);
                      }}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  {mainImageURL ? (
                    <Box sx={{ height: '75px', width: '75px' }}>
                      <Avatar variant="square" sx={{ width: '100%', height: 75 }}>
                        <img style={{ height: 75 }} src={mainImageURL} alt="Uploaded" />
                      </Avatar>
                    </Box>
                  ) : (
                    ''
                  )}

                  <Box mb={2}>
                    <Typography>Image</Typography>
                    <Button variant="contained" component="label" startIcon={<Upload />} fullWidth style={{ marginBottom: '10px' }}>
                      Upload Image
                      <input type="file" hidden onChange={handleChangeFile} />
                    </Button>
                    <Typography variant="caption" color="error">
                      {errors.images}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box mb={2}>
                    <TextField
                      fullWidth
                      label="Description"
                      variant="outlined"
                      multiline
                      rows={4}
                      onChange={(e) => setDescription(e.target.value)}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={12}>
                  <Box mb={2}>
                    <TextField
                      fullWidth
                      label="Object Position Value"
                      variant="outlined"
                      type="number"
                      onChange={(e) => setObjectPositionValue(Number(e.target.value))}
                    />
                  </Box>
                </Grid>

                <Grid item xs={12} md={12} mt={2}>
                  <Button variant="contained" color="primary" onClick={handleClickAdd} fullWidth>
                    Add Member
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={3.5}></Grid>
          </Grid>
        </Grid>
      </Grid>
      <SimpleModal isOpen={open} onClose={handleClose} title={'Image size should not be above 500kb'} />
    </Grid>
  );
};

export default AddTeams;
